module.exports = __webpack_public_path__ + "img/Secondary-chevron.9bb7968d.svg";